/* JAWS scroll-reveal (signature block #3, editorial layer).
 * Progressive enhancement: elements are only hidden once this script has run
 * (it adds `jaws-reveal-ready` to <html>), so if JS fails the content stays
 * visible. Motion is gated by the --jaws-reveal-* tokens, which collapse to 0
 * when the merchant disables motion OR the visitor prefers reduced motion.
 *
 * Usage: add class="jaws-reveal" to any element (optionally data-jaws-reveal-delay="120").
 */
(function () {
  var root = document.documentElement;

  function reveal() {
    var els = document.querySelectorAll('.jaws-reveal');
    if (!els.length) return;

    // In the Shopify theme editor, never hide content — so edits render live
    // (no blank-until-save). The hidden CSS only applies once we add the class.
    if (window.Shopify && window.Shopify.designMode) return;

    // Mark ready so the hidden-initial CSS applies only when JS is alive.
    root.classList.add('jaws-reveal-ready');

    if (!('IntersectionObserver' in window)) {
      // No IO support: just show everything.
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-jaws-reveal-delay') || '0', 10);
        if (delay > 0) {
          el.style.transitionDelay = delay + 'ms';
        }
        el.classList.add('is-revealed');
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
